import { render, staticRenderFns } from "./KYRYPieChart.vue?vue&type=template&id=3fb8900a&scoped=true"
import script from "./KYRYPieChart.vue?vue&type=script&lang=js"
export * from "./KYRYPieChart.vue?vue&type=script&lang=js"
import style0 from "./KYRYPieChart.vue?vue&type=style&index=0&id=3fb8900a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb8900a",
  null
  
)

export default component.exports